var ko = require('knockout'),
  APIHelper = require('_js/APIHelper');
require('knockout-postbox');

function FindAccountantsRN(params) {
  var self = this;
  self.API = params.api;
  self.accountantsHitText = params.texts.accountantsHitText;
  self.title = params.texts.title;
  self.description = params.texts.description;
  self.accountantList = ko.observableArray([]);
  self.accountantFilteredList = ko.observableArray([]);
  self.showClearQuery = ko.observable(false);
  self.query = ko.observable('');
  self.query.subscribe(self.search, this);
  self.map = ko.observable();
  self.infoWindow = ko.observable();
  self.markers = ko.observableArray([]);
  self.numberOfShowingAccountants = ko.observable();
  self.loading = ko.observable(true);
  self.clickedOnAccountant = function(index, item) {
    var marker = ko.utils.arrayFirst(self.markers(), function(m) {
      return m.title == item.Name;
    });
    var position = marker.getPosition();
    var label =
      "<div class='info-window'><div class='info-window-header'><h3>" +
      item.Name +
      '</h3></div>';
    label +=
      "<div class='info-window-form'><span class='form-label'>Adresse</span><span class='form-value'>" +
      item.StreetAddress +
      ', ' +
      (item.StreetPostCode ? item.StreetPostCode : '') +
      ' ' +
      item.StreetCity +
      '</span> </div>';
    label += item.OfficePhone
      ? "<div class='info-window-form'><span class='form-label'>Telefon</span><span class='form-value'>" +
        "<a href='tel:" +
        item.OfficePhone +
        "'>" +
        item.OfficePhone +
        '</a></span> </div>'
      : '';
    label += item.Email
      ? "<div class='info-window-form'><span class='form-label'>E-post</span><span class='form-value'>" +
        "<a href='mailto:" +
        item.Email +
        "'>" +
        item.Email +
        '</a></span> </div>'
      : '';
    label += item.Website
      ? "<div class='info-window-form'><span class='form-label'>Nettside</span><span class='form-value'>"
      : '';
    label += item.Website
      ? "<a target='_blank' href='https://" +
        item.Website +
        "'>" +
        item.Website +
        '</a></span></div></div>'
      : '';

    if (self.infoWindow()) {
      self.infoWindow().close();
    }
    self.infoWindow().setContent(label);
    self.infoWindow().open(self.map(), marker);
    self.map().panTo(position);
    self.map().setZoom(18);
  };
  self.init();
}

FindAccountantsRN.prototype.init = function() {
  this.getAccountants();
};

FindAccountantsRN.prototype.search = function(value) {
  var self = this;
  var filteredItems = self.accountantList();

  filteredItems = ko.utils.arrayFilter(filteredItems, function(item) {
    return item.Name.toLowerCase().includes(value.toLowerCase());
  });

  self.numberOfShowingAccountants(filteredItems.length);
  self.accountantFilteredList(filteredItems);
  if (value == '') {
    self.showClearQuery(false);
  } else {
    self.showClearQuery(true);
  }
};

self.clearQuery = function() {
  var self = this;
  self.query('');
};

ko.bindingHandlers.googleMap = {
  init: function(mapDiv, valueAccessor, allBindingsAccessor, data, context) {
    var markers,
      map,
      infoWindow,
      mapData = data.accountantList(),
      myLatLng = { lat: 65.891469, lng: 8.822599 };
    map = new google.maps.Map(mapDiv, {
      zoom: 4,
      center: myLatLng
    });
    infoWindow = new google.maps.InfoWindow({
      content: '',
      disableAutoPan: false
    });

    markers = mapData.map(function(item) {
      var label =
        "<div class='info-window'><div class='info-window-header'><h3>" +
        item.Name +
        '</h3></div>';
      label +=
        "<div class='info-window-form'><span class='form-label'>Adresse</span><span class='form-value'>" +
        item.StreetAddress +
        ', ' +
        (item.StreetPostCode ? item.StreetPostCode : '') +
        ' ' +
        item.StreetCity +
        '</span> </div>';
      label += item.OfficePhone
        ? "<div class='info-window-form'><span class='form-label'>Telefon</span><span class='form-value'>" +
          "<a href='tel:" +
          item.OfficePhone +
          "'>" +
          item.OfficePhone +
          '</a></span> </div>'
        : '';
      label += item.Email
        ? "<div class='info-window-form'><span class='form-label'>E-post</span><span class='form-value'>" +
          "<a href='mailto:" +
          item.Email +
          "'>" +
          item.Email +
          '</a></span> </div>'
        : '';
      label += item.Website
        ? "<div class='info-window-form'><span class='form-label'>Nettside</span><span class='form-value'>"
        : '';
      label += item.Website
        ? "<a target='_blank' href='https://" +
          item.Website +
          "'>" +
          item.Website +
          '</a></span></div></div>'
        : '';

      var marker = new google.maps.Marker({
        position: new google.maps.LatLng(item.Latitude, item.Longitude),
        title: item.Name
      });

      // markers can only be keyboard focusable when they have click listeners
      // open info window when marker is clicked
      marker.addListener('click', function() {
        var markersOnSamePosition = [];
        for (var j = 0; j < mapData.length; j++) {
          if (
            mapData[j].Latitude == item.Latitude &&
            mapData[j].Longitude == item.Longitude
          ) {
            markersOnSamePosition.push(mapData[j]);
          }
        }
        if (markersOnSamePosition.length > 1) {
          label = "<div class='info-window'>";
          for (var i = 0; i < markersOnSamePosition.length; i++) {
            if (i > 0) {
              label += '<hr>';
            }
            label +=
              "<div class='info-window-part'><div class='info-window-header'><h3>" +
              markersOnSamePosition[i].Name +
              '</h3></div>';
            label +=
              "<div class='info-window-form'><span class='form-label'>Adresse</span><span class='form-value'>" +
              markersOnSamePosition[i].StreetAddress +
              ', ' +
              (markersOnSamePosition[i].StreetPostCode
                ? markersOnSamePosition[i].StreetPostCode
                : '') +
              ' ' +
              markersOnSamePosition[i].StreetCity +
              '</span> </div>';
            label += markersOnSamePosition[i].OfficePhone
              ? "<div class='info-window-form'><span class='form-label'>Telefon</span><span class='form-value'>" +
                "<a href='tel:" +
                markersOnSamePosition[i].OfficePhone +
                "'>" +
                markersOnSamePosition[i].OfficePhone +
                '</a></span> </div>'
              : '';
            label += markersOnSamePosition[i].Email
              ? "<div class='info-window-form'><span class='form-label'>E-post</span><span class='form-value'>" +
                "<a href='mailto:" +
                markersOnSamePosition[i].Email +
                "'>" +
                markersOnSamePosition[i].Email +
                '</a></span> </div>'
              : '';
            label += markersOnSamePosition[i].Website
              ? "<div class='info-window-form'><span class='form-label'>Nettside</span><span class='form-value'>"
              : '';
            label += markersOnSamePosition[i].Website
              ? "<a target='_blank' href='https://" +
                markersOnSamePosition[i].Website +
                "'>" +
                markersOnSamePosition[i].Website +
                '</a></span></div></div>'
              : '</div>';
          }
          label += '</div>';
        }
        infoWindow.setContent(label);
        infoWindow.open(map, marker);
      });
      return marker;
    });

    // Add a marker clusterer to manage the markers.
    new MarkerClusterer(map, markers, {
      imagePath:
        'https://cdn.rawgit.com/googlemaps/js-marker-clusterer/gh-pages/images/m',
      maxZoom: 17
    });

    context.$data.map(map);
    context.$data.markers(markers);
    context.$data.infoWindow(infoWindow);
  }
};

FindAccountantsRN.prototype.getAccountants = function() {
  var self = this;
  var url = self.API.accountants;
  APIHelper.get(
    url,
    function(response) {
      self.accountantList(response);
      self.accountantFilteredList(response);
      self.numberOfShowingAccountants(response.length);
      self.loading(false);
    }.bind(this),
    function(response) {
      var location = window.location.href || document.URL;
      self.loading(false);
      APIHelper.post('/api/log/error', {
        message: 'API-error: find-accountants.js',
        context: location,
        parameters: [
          'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
          'platform: ' + navigator.platform,
          'responseText: ' + response.responseText,
          'status: ' + response.status,
          'statusText: ' + response.statusText,
          'requestUrl: ' + url
        ]
      });
    }
  );
};

module.exports = FindAccountantsRN;
